// Filename: collections/activitys
define('collections/calendar/session/animations',[
    'underscore',
    'backbone',
    'mustache',
    'moment',
    'utils',
    'services/api',
    // super class
    'src/plugins/infinite-collection',
    // models
    'models/calendar/session/animation'
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    // src
    API,
    // super class
    InfiniteCollection,
    // model
    MAnimation
) {

    var CAnimations = InfiniteCollection.extend({
        model: MAnimation,
        url: function() {
            var url = API.url("exercises/");
            if (!_.isEmpty(this.searchText))
                url = url + "?searchText=" + this.searchText;

            return url;
        },
        state: {
            pageSize: 200,
        },
        queryParams: {
            tags: function() {
                var indexOfNullFilter = this.tags.indexOf("000000000000000000000000");
                if (indexOfNullFilter > -1) {
                    this.tags.splice(indexOfNullFilter, 1);
                }

                if (_.isEmpty(this.tags)) {
                    return null;
                }
                return this.tags.join();
            },
            searchText: function() {
                if (_.isEmpty(this.searchText)) {
                    return null;
                }
                return this.searchText;
            },
            skip: function() {
                return 0;
            },
        },

        initialize: function(models, opt) {
            opt = opt || {};
            this.resetFilter();
        },

        setFilter: function(tags, searchText) {
            this.tags = tags;
            this.searchText = searchText;
            return this;
        },

        setSearchTextFilter: function(searchText) {
            this.searchText = searchText;
            return this;
        },

        resetFilter: function() {
            this.setFilter(["000000000000000000000000"], "");
            this.searchText = "";
            return this;
        },

        getFilter: function() {
          return this.tags.filter(function(tagId) {
              return tagId !== "000000000000000000000000";
          });
        },

        getTagsFilter: function() {
          return this.tags.filter(function(tagId) {
              return tagId !== "000000000000000000000000";
          });
        },

        getModelsId: function() {
            return this.pluck(this.model.prototype.idAttribute);
        },
    });

    return CAnimations;
});

